import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label} from 'ng2-charts';
import { retryWhen, take, delayWhen, tap} from 'rxjs/operators'
import { timer } from 'rxjs';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  @Input() search: any;
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartLabels: Label[] = [['WIN'], ['LOSS'],['DRAW']];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public chartColors: Array<any> = [
    { // all colors in order
      backgroundColor: ['#98ba6f', '#c0070b','#cccccc'] 
    }
  ]

  constructor(
    private http : HttpClient
  ) { }

  username:any;
  name:any;
  elo:any;
  loading:any;
  count:any;
  ngOnInit(): void {
    
  }
  ngOnChanges(){
    this.start();
    this.pieChartData = [];
    this.username = "";
    this.name="";
    this.elo="";
    this.loading = false;
    this.count = 0;
  }
  myType = 'PieChart';
  
  start(){
    let query = 'https://api.chess.com/pub/player/'+this.search

    this.http.get(query)
    .pipe(
      retryWhen(errors => {
          return errors
                  .pipe(
                      delayWhen(() => timer(2000)),
                      tap(() => this.count++),
                      take(3)
                  );
      } )
  )
    .subscribe((response:any)=>{
        console.log(response);
        this.username=response.username;
        this.name=response.name;
      })


    this.http.get(query+"/stats").pipe(
      retryWhen(errors => {
          return errors
                  .pipe(
                      delayWhen(() => timer(2000)),
                      take(3)
                  );
      } )
  )
    .subscribe((response:any)=>{
        if(response.chess_rapid !== undefined){
          this.elo=response.chess_rapid.last.rating;
          this.pieChartData = [parseInt(response.chess_rapid.record.win),parseInt(response.chess_rapid.record.loss),parseInt(response.chess_rapid.record.draw)]
          this.loading = true;
        }else{
          this.elo="No records available";
          this.loading = true;
        }
      })
  }
}
